import { render } from "./BuffonSimulation.vue?vue&type=template&id=bad99d92&scoped=true"
import script from "./BuffonSimulation.vue?vue&type=script&lang=js"
export * from "./BuffonSimulation.vue?vue&type=script&lang=js"

import "./BuffonSimulation.vue?vue&type=style&index=0&id=bad99d92&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bad99d92"]])

export default __exports__